(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/svs-suspension-dialog.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/svs-suspension-dialog.js');

'use strict';

const SUSPENSION_PRODUCT_ID = svs.spelpaus.constants.SUSPENSION_PRODUCT_ID;

const showSetSuspensionConfirmationDialogAsync = async suspension => new Promise((resolve, reject) => {
  svs.spelpaus.logger.debug('setSuspensionCustomerServiceDialog: ', suspension);
  const _svs$spelpaus$pages$s = svs.spelpaus.pages.svsSuspension.SvsSuspensionHelper,
    getProductText = _svs$spelpaus$pages$s.getProductText,
    getSuspensionTypeText = _svs$spelpaus$pages$s.getSuspensionTypeText;
  const suspensionLine = "Pausen g\xE4ller ".concat(getProductText(suspension.product, suspension.type, false), " ").concat(getSuspensionTypeText(suspension.period, suspension.termination), ".");
  const durationLine = suspension.period ? "Spelpausen upph\xF6r automatiskt efter ".concat(getSuspensionTypeText(suspension.period, suspension.terminationPeriod), ".") : "Kontakta Kundservice efter spelpaus f\xF6r att aktivera ".concat(getProductText(suspension.product, suspension.type, false), ".");
  const dialog = new svs.ui.dialog.Confirm({
    title: 'Vill du aktivera en spelpaus?',
    icon: 'spelpaus',
    branding: svs.ui.dialog.branding.TUR,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: suspensionLine
    }, {
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: durationLine
    }],
    actions: [{
      title: 'Avbryt',
      callback() {
        dialog.close();
        reject();
      }
    }, {
      title: 'Aktivera Spelpaus',
      callback() {
        dialog.close();
        resolve();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});

const showSetSuspensionSuccessDialog = async (suspension, accountBalance) => {
  svs.spelpaus.logger.debug('showSetSuspensionSuccessDialog: suspension, accountBalance ', suspension, accountBalance);
  const hasAllGameSuspension = suspension && (suspension === null || suspension === void 0 ? void 0 : suspension.product) === SUSPENSION_PRODUCT_ID.ALL && (suspension === null || suspension === void 0 ? void 0 : suspension.type) === 'timeOngoing';
  const _svs$spelpaus$pages$s2 = svs.spelpaus.pages.svsSuspension.SvsSuspensionHelper,
    getProductText = _svs$spelpaus$pages$s2.getProductText,
    getSuspensionTypeText = _svs$spelpaus$pages$s2.getSuspensionTypeText;
  const suspensionText = "Du har tagit en spelpaus fr\xE5n ".concat(getProductText(suspension.product, suspension.type, false), " i ").concat(getSuspensionTypeText(suspension.period, suspension.termination), ".");

  const dialog = new svs.ui.dialog.Confirm({
    icon: 'thumbs-up',
    branding: svs.ui.dialog.branding.TUR,
    title: 'Spelpaus aktiverad!',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      align: 'center',
      text: suspensionText
    }],
    actions: [{
      title: 'Okej',
      callback() {
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);

  const accountBalanceText = "Ditt saldo: ".concat(svs.utils.format.Currency(accountBalance), " kr");
  if (hasAllGameSuspension && parseInt(accountBalance, 10) > 0) {
    const dialog = new svs.ui.dialog.Confirm({
      title: 'Du kan ta ut ditt kvarvarande saldo på uttagssidan',
      icon: 'withdrawal',
      branding: svs.ui.dialog.branding.TUR,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        align: 'center',
        text: accountBalanceText
      }],
      actions: [{
        title: 'Okej',
        callback() {
          location.href = svs.core.urlMapping.get('transactionsWithdrawal');
          dialog.close();
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  }
};

const showSetSuspensionErrorDialogAsync = _ref => {
  let _ref$code = _ref.code,
    code = _ref$code === void 0 ? 0 : _ref$code,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? '' : _ref$message;
  let messageBoxOptions = {
    title: 'Tekniskt fel',
    message: 'Kontakta kundservice: 0770 - 11 11 11',
    type: svs.ui.dialog.type.ERROR,
    buttons: [{
      text: 'Stäng'
    }]
  };
  switch (code) {
    case 225:
      messageBoxOptions = {
        title: 'Önskad spelpaus redan aktiverad!',
        message: 'Du har en pågående spelpaus som omfattar den önskade perioden.',
        type: svs.ui.dialog.type.INFO,
        buttons: [{
          text: 'Stäng'
        }]
      };
      break;
    case 173:
      svs.spelpaus.logger.info("Error posting suspension: error code: ".concat(code, ", message:").concat(message));
      messageBoxOptions = {
        title: 'Pågående Vegasspel',
        message: 'Det gick ej att sätta paus. Avsluta ditt Vegasspel och försök igen.',
        type: svs.ui.dialog.type.INFO,
        buttons: [{
          text: 'Stäng'
        }]
      };
      break;
    case 101: 
    case 12580:
      svs.spelpaus.logger.info("Error posting suspension: error code: ".concat(code, ", message:").concat(message));
      messageBoxOptions = {
        title: 'Tekniskt fel',
        message: 'Var vänlig och försök igen om en liten stund',
        type: svs.ui.dialog.type.INFO,
        buttons: [{
          text: 'Stäng'
        }]
      };
      break;
    case 210: 
    case 255: 
    case 156:
      svs.spelpaus.logger.warn("Error posting suspension: error code: ".concat(code, ", message: ").concat(message));
      break;
    default:
      svs.spelpaus.logger.warn("Error posting suspension, unknown error code: ".concat(code, ", message: ").concat(message));
  }
  const dialog = new svs.ui.dialog.Confirm({
    title: messageBoxOptions.title,
    icon: 'spelpaus',
    branding: svs.ui.dialog.branding.TUR,
    type: messageBoxOptions.type,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: messageBoxOptions.message
    }],
    actions: [{
      title: 'Stäng'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.spelpaus.pages.svsSuspension.SvsSuspensionDialog = {
  showSetSuspensionConfirmationDialogAsync,
  showSetSuspensionSuccessDialog,
  showSetSuspensionErrorDialogAsync
};

 })(window);